import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
    AppBar,
    Box,
    Toolbar,
    makeStyles,
    Typography,
    Button,
    Hidden,
    IconButton
} from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import Logo from 'src/components/Logo';
import { APP_VERSION, DOMAIN_PROPERTIES, THEMES } from 'src/constants';
import Account from '../Account';
import sections from './sections';

const useStyles = makeStyles((theme) => ({
    root: {
        zIndex: theme.zIndex.drawer + 100,
        ...(theme.name === THEMES.LIGHT ? {
            boxShadow: 'none',
            backgroundColor: theme.palette.primary.main,
            color: '#ffffff'
        } : {
            backgroundColor: theme.palette.background.default,
            color: theme.palette.text.primary
        })
    },
    toolbar: {
        minHeight: 64,
        display: 'flex',
        justifyContent: 'space-between', 
        alignItems: 'center',
        padding: theme.spacing(0, 2)
    },
    sideContainer: {
        display: 'flex',
        alignItems: 'center',
    },
    logo: {
        marginRight: theme.spacing(1)
    },
    versionText: {
        color: 'inherit',
        opacity: 0.7,
        whiteSpace: 'nowrap'
    },
    tabsWrapper: {
        display: 'flex',
        flexGrow: 1,
        justifyContent: 'center', 
        gap: theme.spacing(2),
        [theme.breakpoints.down('md')]: {
            display: 'none'
        }
    },
    tabButton: {
        color: 'inherit',
        minWidth: 'auto',
        padding: '6px 100px',
        lineHeight: '1.2',
        textAlign: 'center',
        textTransform: 'none',
        whiteSpace: 'nowrap',
        '&:hover': {
            backgroundColor: 'rgba(255, 255, 255, 0.12)'
        }
    }
}));

const TopBar = ({ className, onMobileNavOpen, ...rest }) => {
    const classes = useStyles();

    return (
        <AppBar
            className={clsx(classes.root, className)}
            elevation={0}
            {...rest}
        >
            <Box
                height={5}
                style={{ backgroundColor: DOMAIN_PROPERTIES[window.location.host]?.barColor || 'transparent' }}
            />
            
            <Toolbar className={classes.toolbar}>
                <Box className={classes.sideContainer}>
                    <Hidden lgUp>
                        <IconButton
                            color="inherit"
                            onClick={onMobileNavOpen}
                        >
                            <MenuIcon />
                        </IconButton>
                    </Hidden>      
                    <Hidden mdDown>
                        <RouterLink to='/'>
                            <Logo className={classes.logo} />
                        </RouterLink>
                        <Typography variant='caption' className={classes.versionText}>
                            v{APP_VERSION}
                        </Typography>
                    </Hidden>
                </Box>

                <Box className={classes.tabsWrapper}>
                    {sections.map((section, index) => (
                        <Button
                            key={index}
                            className={classes.tabButton}
                            component={RouterLink}
                            to={section.href}
                        >
                            {section.title}
                        </Button>
                    ))}
                </Box>

                <Box className={classes.sideContainer} style={{ justifyContent: 'flex-end' }}>
                    <Account accountPath={'/app/patient/account'} />
                </Box>
            </Toolbar>
        </AppBar>
    );
};

TopBar.propTypes = {
    className: PropTypes.string,
    onMobileNavOpen: PropTypes.func
};

TopBar.defaultProps = {
    onMobileNavOpen: () => {}
};

export default TopBar;